import { type RBushItem } from '@/microfrontends/map/shared/types/Map';

export const rbushEquals = (a: RBushItem, b: RBushItem): boolean =>
  a.cluster.id === b.cluster.id &&
  JSON.stringify(a.cluster.geometry.coordinates) === JSON.stringify(b.cluster.geometry.coordinates);
